<div class="email-container px-3">

  <div class="row">
    <div class="col-md-3 col-lg-3 col-xl-2 bg-white border-right">
      <!-- style="padding-top: 40px;">-->
      <div class=" p-2" style="background-color: rgba(21, 0, 254, 0.502);">
        <div class="d-flex justify-content-end">
          <a href="javascript:void(0)" (click)="AbilitaModifiche()" class="btn bg-white text-success py-1 px-2 link"
            placement="bottom" ngbTooltip="Abilita Modifiche">
            <i class="fas fa-pencil-alt"></i>
          </a>
          <a href="javascript:void(0)" (click)="openModal(editTicketModal, null, null)" placement="bottom"
            ngbTooltip="Aggiungi" class="btn bg-white text-info py-1 px-2 link ">
            <i-feather name="plus" class="feather-sm"></i-feather>
          </a>
        </div>
      </div>
      <div class="inbox-panel p-2 bg-white">
        <ul class="list-group custom-group message-center" id="sidebar">
          <!-- First level menu -->
          <li class=" list-group-item " style="padding-right: 0; padding-bottom: 0;"
            *ngFor="let sidebarnavItem of sidebarnavItems">
            <a href="javascript:void(0)" (click)="clicked(sidebarnavItem)"
              class="message-item d-flex align-items-center border-0 font-weight-normal text-dark">
              <i *ngIf="sel_cat_id === sidebarnavItem.id" class=" text-info fa-folder fas font-18 mr-2"></i>
              <i *ngIf="sel_cat_id !== sidebarnavItem.id" class="fa-folder fas font-18 mr-2"></i>
              {{sidebarnavItem.categoria}}
              <div *ngIf="modificheAbilitate" class="ml-auto">
                <a href="javascript:void(0)" (click)="openModal(editTicketModal, sidebarnavItem, null)"
                  class="btn bg-white text-success py-1 px-2 link" placement="bottom" ngbTooltip="Modifica">
                  <i class="fas fa-pencil-alt"></i>
                </a>
                <a href="javascript:void(0)" (click)="openModal(DeleteCategoriaModal, sidebarnavItem, null)"
                  class="btn bg-white text-danger py-1 px-2 link" placement="bottom" ngbTooltip="Elimina">
                  <i-feather name="trash-2" class="feather-sm"></i-feather>
                </a>
              </div>
            </a>
            <ul *ngIf="sidebarnavItem.figli && sidebarnavItem.figli.length > 0"
              class="list-group custom-group message-center" id="sidebar">
              <!-- Second level menu -->
              <li class="list-group-item  " style="padding-right: 0; padding-bottom: 0;"
                *ngFor="let item of sidebarnavItem.figli">
                <a href="javascript:void(0)" (click)="clicked(item)"
                  class="message-item d-flex align-items-center border-0  font-weight-normal text-dark">
                  <i *ngIf="sel_cat_id === item.id" class=" text-info fa-folder fas font-18 mr-2"></i>
                  <i *ngIf="sel_cat_id !== item.id" class="fa-folder fas font-18 mr-2"></i>
                  {{item.categoria}}
                  <div *ngIf="modificheAbilitate" class="ml-auto">
                    <a href="javascript:void(0)" (click)="openModal(editTicketModal, item, sidebarnavItem)"
                      class="btn bg-white text-success py-1 px-2 link" placement="bottom" ngbTooltip="Modifica">
                      <i class="fas fa-pencil-alt"></i>
                    </a>
                    <a href="javascript:void(0)" (click)="openModal(DeleteCategoriaModal, item, sidebarnavItem)"
                      class="btn bg-white text-danger py-1 px-2 link" placement="bottom" ngbTooltip="Elimina">
                      <i-feather name="trash-2" class="feather-sm"></i-feather>
                    </a>
                  </div>
                </a>
                <ul *ngIf="item.figli && item.figli.length > 0" class="list-group custom-group message-center"
                  id="sidebar">
                  <!-- third level menu -->
                  <li class="list-group-item" style="padding-right: 0; padding-bottom: 0;"
                    *ngFor="let item2 of item.figli">
                    <a href="javascript:void(0)" (click)="clicked(item2)"
                      class="message-item d-flex align-items-center border-0  font-weight-normal text-dark">
                      <i *ngIf="sel_cat_id === item2.id" class=" text-info fa-folder fas font-18 mr-2"></i>
                      <i *ngIf="sel_cat_id !== item2.id" class="fa-folder fas font-18 mr-2"></i>
                      {{item2.categoria}}
                      <div *ngIf="modificheAbilitate" class="ml-auto">
                        <a href="javascript:void(0)" (click)="openModal(editTicketModal, item2, item)"
                          class="btn bg-white text-success py-1 px-2 link" placement="bottom" ngbTooltip="Modifica">
                          <i class="fas fa-pencil-alt"></i>
                        </a>
                        <a href="javascript:void(0)" (click)="openModal(DeleteCategoriaModal, item2, item)"
                          class="btn bg-white text-danger py-1 px-2 link" placement="bottom" ngbTooltip="Elimina">
                          <i-feather name="trash-2" class="feather-sm"></i-feather>
                        </a>
                      </div>
                    </a>
                    <ul *ngIf="item2.figli&&item2.figli.length > 0" class="list-group custom-group message-center"
                      id="sidebar">
                      <!-- 4 level menu -->
                      <li class="list-group-item " style="padding-right: 0; padding-bottom: 0;"
                        *ngFor="let item3 of item2.figli">
                        <a href="javascript:void(0)" (click)="clicked(item3)"
                          class="message-item d-flex align-items-center border-0  font-weight-normal text-dark">
                          <i *ngIf="sel_cat_id === item3.id" class=" text-info fa-folder fas font-18 mr-2"></i>
                          <i *ngIf="sel_cat_id !== item3.id" class="fa-folder fas font-18 mr-2"></i>
                          {{item3.categoria}}
                          <div *ngIf="modificheAbilitate" class="ml-auto">
                            <a href="javascript:void(0)" (click)="openModal(editTicketModal, item3, item2)"
                              class="btn bg-white text-success py-1 px-2 link" placement="bottom" ngbTooltip="Modifica">
                              <i class="fas fa-pencil-alt"></i>
                            </a>
                            <a href="javascript:void(0)" (click)="openModal(DeleteCategoriaModal, item3, item2)"
                              class="btn bg-white text-danger py-1 px-2 link" placement="bottom" ngbTooltip="Elimina">
                              <i-feather name="trash-2" class="feather-sm"></i-feather>
                            </a>
                          </div>
                        </a>
                        <ul *ngIf="item3.figli&&item3.figli.length > 0" class="list-group custom-group message-center"
                          id="sidebar">
                          <!-- 5 level menu -->
                          <li class="list-group-item " style="padding-right: 0; padding-bottom: 0;"
                            *ngFor="let item4 of item3.figli">
                            <a href="javascript:void(0)" (click)="clicked(item4)"
                              class="message-item d-flex align-items-center border-0  font-weight-normal text-dark">
                              <i *ngIf="sel_cat_id === item4.id" class=" text-info fa-folder fas font-18 mr-2"></i>
                              <i *ngIf="sel_cat_id !== item4.id" class="fa-folder fas font-18 mr-2"></i>
                              {{item4.categoria}}
                              <div *ngIf="modificheAbilitate" class="ml-auto">
                                <a href="javascript:void(0)" (click)="openModal(editTicketModal, item4, item3)"
                                  class="btn bg-white text-success py-1 px-2 link" placement="bottom"
                                  ngbTooltip="Modifica">
                                  <i class="fas fa-pencil-alt"></i>
                                </a>
                                <a href="javascript:void(0)" (click)="openModal(DeleteCategoriaModal, item4, item3)"
                                  class="btn bg-white text-danger py-1 px-2 link" placement="bottom"
                                  ngbTooltip="Elimina">
                                  <i-feather name="trash-2" class="feather-sm"></i-feather>
                                </a>
                              </div>
                            </a>
                            <ul *ngIf="item4.figli&&item4.figli.length > 0"
                              class="list-group custom-group message-center" id="sidebar">
                              <!-- 6 level menu -->
                              <li class="list-group-item " style="padding-right: 0; padding-bottom: 0;"
                                *ngFor="let item5 of item4.figli">
                                <a href="javascript:void(0)" (click)="clicked(item5)"
                                  class="message-item d-flex align-items-center border-0  font-weight-normal text-dark">
                                  <i *ngIf="sel_cat_id === item5.id" class=" text-info fa-folder fas font-18 mr-2"></i>
                                  <i *ngIf="sel_cat_id !== item5.id" class="fa-folder fas font-18 mr-2"></i>
                                  {{item5.categoria}}
                                  <div *ngIf="modificheAbilitate" class="ml-auto">
                                    <a href="javascript:void(0)" (click)="openModal(editTicketModal, item5, item4)"
                                      class="btn bg-white text-success py-1 px-2 link" placement="bottom"
                                      ngbTooltip="Modifica">
                                      <i class="fas fa-pencil-alt"></i>
                                    </a>
                                    <a href="javascript:void(0)" (click)="openModal(DeleteCategoriaModal, item5, item4)"
                                      class="btn bg-white text-danger py-1 px-2 link" placement="bottom"
                                      ngbTooltip="Elimina">
                                      <i-feather name="trash-2" class="feather-sm"></i-feather>
                                    </a>
                                  </div>
                                </a>
                                <ul *ngIf="item5.figli && item5.figli.length > 0 "
                                  class="list-group custom-group message-center" id="sidebar">
                                  <!-- 7 level menu -->
                                  <li class=" list-group-item " style="padding-right: 0; padding-bottom: 0;"
                                    *ngFor="let item6 of item5.figli">
                                    <a href="javascript:void(0)" (click)="clicked(item6)"
                                      class="message-item d-flex align-items-center border-0  font-weight-normal text-dark">
                                      <i *ngIf="sel_cat_id === item6.id"
                                        class=" text-info fa-folder fas font-18 mr-2"></i>
                                      <i *ngIf="sel_cat_id !== item6.id" class="fa-folder fas font-18 mr-2"></i>
                                      {{item6.categoria}}
                                      <div *ngIf="modificheAbilitate" class="ml-auto">
                                        <a href="javascript:void(0)" (click)="openModal(editTicketModal, item6, item5)"
                                          class="btn bg-white text-success py-1 px-2 link" placement="bottom"
                                          ngbTooltip="Modifica">
                                          <i class="fas fa-pencil-alt"></i>
                                        </a>
                                        <a href="javascript:void(0)"
                                          (click)="openModal(DeleteCategoriaModal, item6, item5)"
                                          class="btn bg-white text-danger py-1 px-2 link" placement="bottom"
                                          ngbTooltip="Elimina">
                                          <i-feather name="trash-2" class="feather-sm"></i-feather>
                                        </a>
                                      </div>
                                    </a>
                                    <ul *ngIf="item6.figli && item6.figli.length > 0"
                                      class="list-group custom-group message-center" id="sidebar">
                                      <!-- 8 level menu -->
                                      <li class=" list-group-item " style="padding-right: 0; padding-bottom: 0;"
                                        *ngFor="let item7 of item6.figli">
                                        <a href="javascript:void(0)" (click)="clicked(item7)"
                                          class="message-item d-flex align-items-center border-0  font-weight-normal text-dark">
                                          <i *ngIf="sel_cat_id === item7.id"
                                            class=" text-info fa-folder fas font-18 mr-2"></i>
                                          <i *ngIf="sel_cat_id !== item7.id" class="fa-folder fas font-18 mr-2"></i>
                                          {{item7.categoria}}
                                          <div *ngIf="modificheAbilitate" class="ml-auto">
                                            <a href="javascript:void(0)"
                                              (click)="openModal(editTicketModal, item7, item6)"
                                              class="btn bg-white text-success py-1 px-2 link" placement="bottom"
                                              ngbTooltip="Modifica">
                                              <i class="fas fa-pencil-alt"></i>
                                            </a>
                                            <a href="javascript:void(0)"
                                              (click)="openModal(DeleteCategoriaModal, item7, item6)"
                                              class="btn bg-white text-danger py-1 px-2 link" placement="bottom"
                                              ngbTooltip="Elimina">
                                              <i-feather name="trash-2" class="feather-sm"></i-feather>
                                            </a>
                                          </div>
                                        </a>
                                        <ul *ngIf="item7.figli && item7.figli.length > 0"
                                          class="list-group custom-group message-center" id="sidebar">
                                          <!-- 9 level menu -->
                                          <li class=" list-group-item " style="padding-right: 0; padding-bottom: 0;"
                                            *ngFor="let item8 of item7.figli">
                                            <a href="javascript:void(0)" (click)="clicked(item8)"
                                              class="message-item d-flex align-items-center border-0  font-weight-normal text-dark">
                                              <i *ngIf="sel_cat_id === item8.id"
                                                class=" text-info fa-folder fas font-18 mr-2"></i>
                                              <i *ngIf="sel_cat_id !== item8.id" class="fa-folder fas font-18 mr-2"></i>
                                              {{item8.categoria}}
                                              <div *ngIf="modificheAbilitate" class="ml-auto">
                                                <a href="javascript:void(0)"
                                                  (click)="openModal(editTicketModal, item8, item7)"
                                                  class="btn bg-white text-success py-1 px-2 link" placement="bottom"
                                                  ngbTooltip="Modifica">
                                                  <i class="fas fa-pencil-alt"></i>
                                                </a>
                                                <a href="javascript:void(0)"
                                                  (click)="openModal(DeleteCategoriaModal, item8, item7)"
                                                  class="btn bg-white text-danger py-1 px-2 link" placement="bottom"
                                                  ngbTooltip="Elimina">
                                                  <i-feather name="trash-2" class="feather-sm"></i-feather>
                                                </a>
                                              </div>
                                            </a>
                                            <ul *ngIf="item8.figli && item8.figli.length > 0"
                                              class="list-group custom-group message-center" id="sidebar">
                                              <!-- third level menu -->
                                              <li class=" list-group-item " style="padding-right: 0; padding-bottom: 0;"
                                                *ngFor="let item9 of item8.figli">
                                                <a href="javascript:void(0)" (click)="clicked(item9)"
                                                  class="message-item d-flex align-items-center border-0  font-weight-normal text-dark">
                                                  <i *ngIf="sel_cat_id === item9.id"
                                                    class=" text-info fa-folder fas font-18 mr-2"></i>
                                                  <i *ngIf="sel_cat_id !== item9.id"
                                                    class="fa-folder fas font-18 mr-2"></i>
                                                  {{item9.categoria}}
                                                  <div *ngIf="modificheAbilitate" class="ml-auto">
                                                    <a href="javascript:void(0)"
                                                      (click)="openModal(editTicketModal, item9, item8)"
                                                      class="btn bg-white text-success py-1 px-2 link"
                                                      placement="bottom" ngbTooltip="Modifica">
                                                      <i class="fas fa-pencil-alt"></i>
                                                    </a>
                                                    <a href="javascript:void(0)"
                                                      (click)="openModal(DeleteCategoriaModal, item9, item8)"
                                                      class="btn bg-white text-danger py-1 px-2 link" placement="bottom"
                                                      ngbTooltip="Elimina">
                                                      <i-feather name="trash-2" class="feather-sm"></i-feather>
                                                    </a>
                                                  </div>
                                                </a>
                                              </li>
                                            </ul>
                                          </li>
                                        </ul>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="p-3 col-md-9 col-lg-9 col-xl-10 bg-white">
      <div class="inbox-right-panel">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>









<ng-template #editTicketModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editUserLabel">Categoria</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="input-group col-12">
        <div class="">
          <label class="input-group-text" for="nome">Nome Categoria:</label>
        </div>
        <input type="text" [(ngModel)]="LabelCategoria" name="nome" class="form-control">
      </div>
      <div class="col-12">
        <label for="categorie" class="control-label col-form-label">Categorie Padre:</label>
        <ng-multiselect-dropdown style="width: 80%; " [placeholder]="'Seleziona'" name="categorie"
          [data]="CategorieLineare" [(ngModel)]="CategorieSelezionate" [settings]="categoriedropdownSettings"
          (onFilterChange)="filtroCategoria($event)">
        </ng-multiselect-dropdown>
      </div>
    </div>
    <div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
      <button type="submit" (click)="saveModalButton()"
        class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Salva </span>
        <i-feather name="save" class="feather-md "></i-feather>
      </button>
    </div>
  </div>
</ng-template>


<ng-template #DeleteCategoriaModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editUserLabel">Elimina Categoria</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <label for="categorie" class="control-label col-form-label">Categorie a cui assegnare le categorie
          figlie:</label>
        <ng-multiselect-dropdown style="width: 80%; " [placeholder]="'Seleziona'" name="categorie"
          [data]="CategorieLineare" [(ngModel)]="CategorieSelezionate" [settings]="categoriedropdownSettings"
          (onFilterChange)="filtroCategoria($event)">
        </ng-multiselect-dropdown>
      </div>
    </div>
    <div class="d-md-flex align-items-center p-3" style="padding-right: 25px; margin-top: 25px;">
      <button type="submit" (click)="deleteModalButton()"
        class="ml-auto btn btn-rounded btn-danger p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Elimina </span>
        <i-feather name="trash-2" class="feather-md "></i-feather>
      </button>
    </div>
  </div>
</ng-template>
